import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { AuthenticationService } from "@app/_services";

@Injectable({ providedIn: "root" })
export class AdminAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserTokenValue;
    if (
      currentUser &&
      (currentUser.roles.includes("admin") ||
        currentUser.roles.includes("superadmin"))
    ) {
      // logged in so return true
      return true;
    }

    if(currentUser){
      // logged in but not authorized
      this.router.navigate(["/no-access"], {
        queryParams: { returnUrl: state.url },
      });
    }
    else{
      // not logged in so redirect to login page with the return url
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: state.url },
      });
    }
    return false;
  }
}
